/**
 * 머무름시간(RT, 분) 표시 형식 — 한 화면의 모든 RT 는 같은 형식이어야 한다.
 *
 * T1 부터 표시 RT 는 (TIC apex 로 스냅한 값이 아니라) 스캔 RT 원값이다. 스캔
 * 블록의 중앙값 `(rt_start + rt_end) / 2` 는 소수 4자리까지 의미가 있고, 그 위로는
 * float 잔여물(3.6035000000000004)이다. 소수 4자리에서 반올림해 잔여물을 지우고,
 * 기본 3자리 · 4자리째가 0 이 아니면 4자리로 보여준다 (7.171 / 7.1705).
 */
export function formatRt(rt: number): string {
  const rounded = Math.round(rt * 1e4) / 1e4;
  const four = rounded.toFixed(4);
  return four.endsWith("0") ? four.slice(0, -1) : four;
}
